"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/document--download/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/document--pdf/24.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/launch/24.js"));
var _4 = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _5 = _interopRequireDefault(require("@carbon/icons-react/lib/video/24.js"));
var _reactRouterDom = require("react-router-dom");
var _ExternalVideo = _interopRequireDefault(require("../VideoSlide/ExternalVideo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.downloadlink-container {\n  max-width: 100%; }\n  .downloadlink-container a,\n  .downloadlink-container div {\n    display: flex;\n    gap: 10px;\n    cursor: pointer;\n    width: auto;\n    max-width: 100%; }\n  .downloadlink-container svg {\n    flex: none; }\n  .downloadlink-container p {\n    text-decoration: underline;\n    color: #000000;\n    width: 100%;\n    max-width: 100%;\n    padding-top: 6px; }\n  .downloadlink-container a {\n    text-decoration: none; }\n  .downloadlink-container a:hover > p {\n    color: #4c4c4c; }\n\n.downloadlink-container.DOWNLOAD p {\n  padding-top: 9px; }\n\n.downloadlink-container.EXTERNAL p {\n  padding-top: 7px; }\n";
  const fileName = "DownloadLink_DownloadLink";
  const element = document.querySelector("style[data-sass-component='DownloadLink_DownloadLink']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const variants = exports.variants = {
  DOWNLOAD: 'DOWNLOAD',
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  VIDEO: 'VIDEO'
};
const Wrapper = _ref => {
  let {
    children,
    variant,
    href,
    to,
    src,
    onClick,
    start_second,
    stop_second,
    openInCurrentTab
  } = _ref;
  return variant === variants.EXTERNAL ? /*#__PURE__*/_react.default.createElement("a", {
    target: openInCurrentTab ? '' : '_blank',
    href: href
  }, children) : variant === variants.DOWNLOAD ? /*#__PURE__*/_react.default.createElement("a", {
    target: openInCurrentTab ? '' : '_blank',
    href: to
  }, children) : variant === variants.VIDEO ? /*#__PURE__*/_react.default.createElement(_ExternalVideo.default, {
    itemSrc: src,
    start_second: start_second,
    stop_second: stop_second
  }, children) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    onClick: onClick,
    to: to || href,
    style: {
      maxWidth: '100%'
    }
  }, children);
};
const Icon = _ref2 => {
  let {
    variant,
    icon,
    usePdfIcon
  } = _ref2;
  const value = icon || variant;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value === variants.DOWNLOAD && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, usePdfIcon ? /*#__PURE__*/_react.default.createElement(_2.default, null) : /*#__PURE__*/_react.default.createElement(_.default, null)), value === variants.EXTERNAL && /*#__PURE__*/_react.default.createElement(_3.default, null), value === variants.INTERNAL && /*#__PURE__*/_react.default.createElement(_4.default, null), value === variants.VIDEO && /*#__PURE__*/_react.default.createElement(_5.default, null));
};
const DownloadLink = _ref3 => {
  let {
    variant,
    text,
    href,
    to,
    src,
    onClick,
    icon,
    openInCurrentTab = false,
    usePdfIcon = false,
    ...rest
  } = _ref3;
  const label = text;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `downloadlink-container ${variant}`
  }, /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    variant: variant,
    href: href,
    to: to,
    src: src,
    onClick: onClick,
    openInCurrentTab: openInCurrentTab
  }, rest), /*#__PURE__*/_react.default.createElement(Icon, {
    variant: variant,
    icon: icon,
    usePdfIcon: usePdfIcon
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-08"
  }, label)));
};
DownloadLink.propTypes = {
  variant: _propTypes.default.oneOf(Object.values(variants)),
  icon: _propTypes.default.oneOf(Object.values(variants)),
  text: _propTypes.default.string.isRequired,
  href: _propTypes.default.string,
  to: _propTypes.default.string,
  src: _propTypes.default.string,
  onClick: _propTypes.default.func,
  openInCurrentTab: _propTypes.default.bool,
  usePdfIcon: _propTypes.default.bool
};
var _default = exports.default = DownloadLink;